<template>

</template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterSubdiscipline',
    mounted () {
      /**
       * Init Select2 for disciplines 
       */
      const searchDisciplines = $('.search-disciplines')

      searchDisciplines.select2({
        placeholder: 'Seleccione una disciplina.',
        ajax: {
          url: '/api/disciplines',
          dataType: 'json',
          headers: {
            'Authorization': `Bearer ${window.access_token}`,
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
        language: {
          noResults: function() {
            return 'Disciplina no encontrada...'
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else {
              label.insertAfter(element)
            }
            label.addClass('invalid-feedback')
          },
          rules: {
            key: {
              required: true,
            },
            title: {
              required: true,
            },
            discipline_id: {
              required: true,
            },
          },
          messages: {
            key: {
              required: 'Este campo es requerido.',
            },
            title: {
              required: 'Este campo es requerido.',
            },
            discipline_id: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
